module.exports = __webpack_public_path__ + "img/4.063ca5b6.png";